import React from "react";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { BannerGridRight } from "../../../assets/svgs";
import { Title } from "../../../components/Shared/PageComponents";

const Sustainability = () => {
  const { myGreenLab } = useStaticQuery(
    graphql`
      query {
        myGreenLab: file(
          relativePath: { eq: "assets/images/our-team/my-green-lab.png" }
        ) {
          childImageSharp {
            gatsbyImageData(layout: FIXED, width: 260)
          }
        }
      }
    `
  );

  return (
    <Container id="sustainability">
      <div>
        <Title>Sustainability</Title>
        <p>
          At Genseq, we recognise the importance of building a more sustainable
          future and are committed to doing our part. As part of our ongoing
          sustainability efforts, we joined the My Green Lab Ambassador program
          to increase awareness and drive positive change within our laboratory
          practices.
          <br />
          <br />
          We're proud to share that we are now officially 
          <strong>Green Lab Certified</strong>, achieving an impressive 
          <strong>93% score</strong>, the highest level of certification
          available. This reflects the steps we've taken to minimise our
          environmental impact and operate as sustainably as possible.
        </p>
        <br />
        <a
          href="/pdfs/green-lab-certificate.pdf"
          download="green-lab-certificate.pdf"
        >
          Download Certificate
        </a>
      </div>
      <Images>
        <ImageContainer>
          <GatsbyImage
            image={getImage(myGreenLab)}
            alt="my green lab ambassador"
          />
        </ImageContainer>
        <SVGContainerRight>
          <BannerGridRight />
        </SVGContainerRight>
      </Images>
    </Container>
  );
};

const Container = styled.section`
  grid-column: 1 / 7;
  padding: 3rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  a {
    text-transform: uppercase;
    font-weight: 600;
    color: var(--genseq-purple);
    margin-top: 1.5rem;
  }
  @media screen and (min-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-column: 2 / 13;
    padding: 0 0 6rem 0;
    gap: 6rem;
  }
  @media screen and (min-width: 1600px) {
    grid-column: 3 / 13;
  }
`;

const Images = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 1fr;
  position: relative;
`;

const ImageContainer = styled.div`
  grid-column: 1/3;
  align-self: center;
  @media screen and (min-width: 1024px) {
    justify-self: end;
  }
`;

const SVGContainerRight = styled.div`
  right: -1.25rem;
  top: 0.5rem;
  position: absolute;
  display: flex;
  z-index: 2;
  width: 100%;
  svg {
    width: 75%;
    height: auto;
    margin-left: auto;
  }
  @media screen and (min-width: 1024px) {
    top: 0;
    right: 0;
    svg {
      width: 60%;
    }
  }
`;

export default Sustainability;
